import type { ReactNode } from "react";
import { useState, useRef, useEffect } from "react";

type CollapsibleProps = {
  isOpen: boolean;
  header: ReactNode;
  children: ReactNode;
};

export default function Collapsible({
  isOpen,
  header,
  children,
}: CollapsibleProps) {
  const contentRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState<string>("0px");

  useEffect(() => {
    if (isOpen && contentRef.current) {
      setHeight(`${contentRef.current.scrollHeight}px`);
    } else {
      setHeight("0px");
    }
  }, [isOpen, children]);

  return (
    <div className="w-full">
      {header}
      <div
        ref={contentRef}
        style={{ height, transition: "height 300ms ease" }}
        className={isOpen ? "overflow-visible" : "overflow-hidden"}
      >
        <div className="p-4">{children}</div>
      </div>
    </div>
  );
}
